import ArcPlcCalculatorWorkspace from "components/Calculators/ArcPlcCalculatorWorkspace";
import SoybeanScnRiskCalculatorWorkspace from "components/Calculators/SoybeanScnRiskCalculatorWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

export const calculatorRoutes = [
  {
    path: "/calculators/arc-plc-projection",
    element: <RouteLayout />,
    children: [{ index: true, element: <ArcPlcCalculatorWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="ARC/PLC Projection Calculator" />,
  },
  {
    path: "/calculators/soybean-scn-risk",
    element: <RouteLayout />,
    children: [{ index: true, element: <SoybeanScnRiskCalculatorWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Soybean SCN Risk Calculator" />,
  },
];
